import { Clickable, FormikField, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

export const { colors, media } = theme;

export const ContentWrapper = styled.div`
  @media (min-width: ${media.md}) {
    max-width: 25rem;
  }
`;

export const MaxTravellerCountP = styled(P)`
  color: ${colors.redDark};
`;

export const PromoField = styled(FormikField)`
  margin-bottom: 0;
  width: 12rem;

  & > input {
    border-radius: 0.25rem;
  }
`;

export const PromoLabel = styled.label`
  margin-right: 0.25rem;
`;

export const PromoLabelWrapper = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
`;

export const PromoP = styled(P)`
  color: ${colors.grey50};
`;

export const StyledCheckbox = styled(FormikField)`
  & > label {
    & > input {
      accent-color: ${colors.purple};
    }
  }
`;

export const StyledClickable = styled(Clickable)`
  color: ${colors.redDark};
  font-weight: bold;
`;
